module.exports = __webpack_public_path__ + "static/media/shuriken (1).841a2d42.png";